import React from 'react';
import TailwindExample from '../components/TailwindExample';

const TailwindView = () => {
  return (
    <div className="container mx-auto px-4">
      <div className="text-center py-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 cursor-pointer tw-text-red-400">Welcome to Tailwind View</h1>
        <p className="text-lg text-gray-600 mb-8">This view demonstrates Tailwind CSS styling in the views folder.</p>
      </div>
      
      <div className="grid grid-cols-3 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Feature Section</h3>
          <p className="text-gray-600">
            This section shows how Tailwind CSS classes can be used to create responsive layouts.
          </p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Component Integration</h3>
          <p className="text-gray-600">
            Below you'll see the TailwindExample component integrated into this view.
          </p>
        </div>
      </div>

      <div className="mt-8">
        <TailwindExample />
      </div>
    </div>
  );
};

export default TailwindView; 